import CardStateHelper from "State/Card/CardStateHelper";
import { IGameState } from "State/Game/IGameState";
import { ProgressStateHelper } from "State/Player/Progress/ProgressStateHelper";
import { LevelStatus } from "../LevelStatus";

export function levelActive(state: IGameState): IGameState {
    if (state.levelState.status !== LevelStatus.INTRO) return state;

    // Add level to list to account for an attempt at the level
    const levels = state.playerState.levels[state.levelState.levelType].slice();
    const currentLevel = ProgressStateHelper.getLevelData(
        state,
        state.levelState.levelNumber,
        state.levelState.levelType
    );

    if (currentLevel === undefined) {
        levels.push({
            levelNumber: state.levelState.levelNumber,
            stars: undefined,
        });
    }

    state = {
        ...state,
        levelState: {
            ...state.levelState,
            status: LevelStatus.ACTIVE,

            // Reset undo history/count at the start of each level.
            cardsState: {
                ...state.levelState.cardsState,
                undoHistory: [],
            },
        },
        playerState: {
            ...state.playerState,
            progress: {
                ...state.playerState.progress,
            },
            levels: {
                ...state.playerState.levels,
                [state.levelState.levelType]: levels,
            },
        },
    };

    state = CardStateHelper.onLevelStarted(state);

    return state;
}